import styles from "./Makers.module.scss";
import ArrowSVG from "../assets/arrow-up-right-light.svg";
import { Pulses } from "./Pulses";

export const Makers = () => {
  return (
    <div className={styles.makers}>
      <div>
        <div className={styles.content}>
          <h4>For makers</h4>
          <div>
            <h2>Flow that</h2>
            <h2 className={`gradient semibold`}>always finds you</h2>
          </div>
          <div className={styles.description}>
            <div>
              <h6>Single Integration, Infinite Opportunity.</h6>
              <p>
                Integrate once, and tap into a growing network of aggregators,
                wallets, and dApps routing flow directly to you.
              </p>
              <div className={styles.link}>
                <a
                  href="https://docs.hashflow.com/hashflow/taker/getting-started-api-v3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
                <img src={ArrowSVG} alt="Arrow" />
              </div>
            </div>
            <div>
              <h6>Cross-Chain, MEV-Protected, Execution-First.</h6>
              <p>
                Clean, high-intent flow with guaranteed settlement—no
                front-running, no surprises.
              </p>
              <div className={styles.link}>
                <a
                  href="https://docs.hashflow.com/hashflow/taker/getting-started-api-v3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
                <img src={ArrowSVG} alt="Arrow" />
              </div>
            </div>
            <div>
              <h6>Optimized by Hashflow.</h6>
              <p>
                We analyze your quote performance, win rates, and flow
                quality—then help you refine and scale your strategy to win more
                trades.
              </p>
              <div className={styles.link}>
                <a
                  href="https://docs.hashflow.com/hashflow/taker/getting-started-api-v3"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
                <img src={ArrowSVG} alt="Arrow" />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.fixed}>
          <div className={styles.sticky}>
            <Pulses />
          </div>
        </div>
      </div>
    </div>
  );
};
